import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Formik } from "formik";
import { BootstrapError, BootstrapField } from "../../helpers/Field";
import * as yup from 'yup';
import { connect } from "react-redux";

let schema = yup.object().shape({
    PrimaryAcct: yup.string().matches(/^[a-zA-Z0-9]*$/, "Invalid characters").required("Required"),
    /*AccountTypeId: yup.number().required("Required"),*/
    SalesOrganization: yup.string().matches(/^[a-zA-Z0-9]*$/, "Invalid characters").required("Required"),
    CompanyCode: yup.string().matches(/^[a-zA-Z0-9]*$/, "Invalid characters").required("Required"),
    Division: yup.string().matches(/^[a-zA-Z0-9]*$/, "Invalid characters").required("Required"),
    DistributionChannel: yup.string().matches(/^[a-zA-Z0-9]*$/, "Invalid characters").required("Required")
});

class ManageUserSapAccount extends Component {

    render() {
        let _salesOrgs = {};
        this.props.salesOrgs.filter(_ => _.active && _.active === "X").forEach(_ => _salesOrgs[_.sales_organization] = _.sales_organization);
        _salesOrgs = Object.keys(_salesOrgs);


        // Formik needs properties as empty strings instead of null.
        for (let propertyName in this.props.account) {
            if (this.props.account[propertyName] === null) {
                this.props.account[propertyName] = ""
            }
        }
        return (
            <div>
                <Formik
                    validationSchema={schema}
                    onSubmit={(values, bag) => {
                        bag.setSubmitting(true);
                        this.props.saveAccount(values).then(() => {
                            bag.setSubmitting(false);
                        })
                    }}
                    initialValues={this.props.account}
                    enableReinitialize={true}
                    render={(props) =>
                        <form onSubmit={props.handleSubmit}>
                            <div className="row">
                                <div className="col-6">
                                    <div className="form-group d-flex flex-row">
                                        <label className="wa-label col-form-label pr-2">Account</label>
                                        <div className="flex-grow-1">
                                            <BootstrapField type="text" name="PrimaryAcct" placeholder={"Account"} />
                                            <BootstrapError name="PrimaryAcct" />
                                        </div>
                                    </div>
                                    {this.props.accountTypes.length > 1 && <div className="form-group d-flex flex-row">
                                        <label className="wa-label col-form-label pr-2 text-nowrap">Account Type</label>
                                        <div className="flex-grow-1">
                                            <BootstrapField component="select" name="AccountTypeId">
                                                <option value="" disabled selected="selected">Account Type</option>
                                                {this.props.accountTypes.map(accountType => {
                                                    return (
                                                        <option value={accountType.AccountTypeId} key={accountType.AccountTypeId}>
                                                            {accountType.AccountTypeValue}
                                                        </option>
                                                    )
                                                })}
                                            </BootstrapField>
                                            <BootstrapError name="AccountTypeId" />
                                        </div>
                                    </div>}
                                    <div className="form-group d-flex flex-row">
                                        <label className="wa-label col-form-label pr-2 text-nowrap">Company Code</label>
                                        <div className="flex-grow-1">
                                            <BootstrapField component="select" name="CompanyCode">
                                                <option value="" disabled selected="selected">Company Code</option>
                                                {this.props.companyCodes.filter(_ => _.active && _.active === "X").map(_ => {
                                                    return (
                                                        <option value={_.company_code} key={_.company_code}>
                                                            {_.company_code}
                                                        </option>
                                                    )
                                                })}
                                            </BootstrapField>
                                            <BootstrapError name="CompanyCode" />
                                        </div>
                                    </div>
                                    <div className="form-group d-flex flex-row">
                                        <label className="wa-label col-form-label pr-2 text-nowrap">Sales Organization</label>
                                        <div className="flex-grow-1">
                                            <BootstrapField component="select" name="SalesOrganization">
                                                <option value="" disabled selected="selected">Account Type</option>
                                                {_salesOrgs.map(sales_organization => {
                                                    return (
                                                        <option value={sales_organization} key={sales_organization}>
                                                            {sales_organization}
                                                        </option>
                                                    )
                                                })}
                                            </BootstrapField>
                                            <BootstrapError name="SalesOrganization" />
                                        </div>
                                    </div>
                                   {/*  //Schindler wanted these hidden. */}
                                    <div className="form-group d-flex flex-row">
                                    <label className="wa-label col-form-label pr-2 text-nowrap">Distribution Channel</label>
                                    <div className="flex-grow-1">
                                    <BootstrapField type="text" name="DistributionChannel" placeholder={"Distribution Channel"}/>
                                    <BootstrapError name="DistributionChannel"/>
                                    </div>
                                    </div>
                                    <div className="form-group d-flex flex-row">
                                    <label className="wa-label col-form-label pr-2 text-nowrap">Company Division</label>
                                    <div className="flex-grow-1">
                                    <BootstrapField type="text" name="Division" placeholder={"Company Division"}/>
                                    <BootstrapError name="Division"/>
                                    </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row justify-content-center">
                                <button type="submit" className={"btn btn-primary"}>Save</button>
                            </div>
                        </form>
                    } />
            </div>
        );
    }
}

ManageUserSapAccount.propTypes = {
    account: PropTypes.object,
    saveAccount: PropTypes.func.isRequired,
};

export default connect((store, props) => ({
    salesOrgs: store.app.config.sap.data.sales_area_data,
    companyCodes: store.app.config.sap.data.company_codes,
}))(ManageUserSapAccount);
